import {
  SelectedData,
  WorkDetailSimpleData,
  WorkSimpleWithDetails,
} from '../../shared/dto/EntityRepository';
import { useImportStationWorkStore } from '../../shared/store/importStationWorkStore';
import { useProjectElementListStore } from '../../shared/store/projectElementStore';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { useModalWorkTagStore } from '../../shared/store/workTagStore';
import { useModalPageStore } from '../../shared/store/pageStore';

export function clearFormationSlotImportModalState() {
  useImportStationWorkStore.getState().clearSimpleList();
  useModalWorkTagStore.getState().clearSelectedModalTags();
  useModalPageStore.getState().resetModalPage();
}

export function useFormationSlotImport() {
  const { standardModal, clearModal } = useModalStore();
  const updateFormationSlotReference = useProjectElementListStore((s) => s.updateFormationSlotReference);

  const importToSlot = (
    selected: SelectedData,
    parentWork?: WorkSimpleWithDetails,
    detail?: WorkDetailSimpleData,
  ) => {
    if (!standardModal?.title || standardModal.value == null) return;

    updateFormationSlotReference(
      standardModal.title,
      Number(standardModal.value),
      selected,
      parentWork,
      detail,
    );
    clearModal();
  };

  return { importToSlot };
}
